export const OrderRoutes = {
  Create: process.env.REACT_APP_API + "create-order",
  Success: process.env.REACT_APP_API + "payment-success",
  GetSinlgeOrder: process.env.REACT_APP_API + "single-order/",
};
